<template>
    <el-dialog width="25%" :title="$t('OrderDetail.tip')" :visible.sync="printvisible" :append-to-body="true">
      <el-select style="width:100%" class="dialogselect" v-model="printType"
        :placeholder="typegather.length != 0 ? $t('OrderDetail.placeholder') : $t('OrderDetail.noneholder')">
        <el-option v-for="item in typegather" :key="item.value" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="print()" type="primary">{{ $t('button.determine') }}</el-button>
      </div>
    </el-dialog>
</template>
<script>
import { PrintReport } from '../utils/ReportPreView'
export default {
  props:{
    billno:{
      type:String,
      default:'',
    },
    progId:{
      type:String,
      default:'',
    },
    BillType:{
      type:String,
      default:'',
    },
  },
  data(){
    return{
      printvisible:false,
      printType:'',
      typegather:[],
      printtemp:'',
      isexcel:false,
    }
  },
  methods:{
    printdialog() {
      this.printvisible = true;
      this.axiosInvoke("/SupplierComm/Handler/VueSysHandler.ashx",
        {
          action: "doprintbill",
          BillNo: this.billno,
          ProgId: this.progId,
          lang: localStorage.getItem("language")
        },
        (res) => {
          var data = eval(res.data);
          this.printtemp = data[0];
          this.typegather = data[0].files;
          this.printType = decodeURIComponent(data[0].printType);
          var printExist = false;
          this.typegather.forEach(v=>{
            if(v.value == this.printType){
              printExist = true;
              return;
            }
          })
          if(!printExist)this.printType = "";
        })
    },
    print() {//打印
      PrintReport(this);
    },
  }
}
</script>
<style scoped>
</style>